
export default {

    checklist_items: {},
    checklist_configurations: {}

}
